import axios, { AxiosError } from "axios";

// current host machine
export const currentHost = `${window.location.protocol}//${window.location.host}`;

export const checkInternetConnectivity = async (): Promise<boolean> => {
  try {
    // Check if the browser is online
    if (!navigator.onLine) {
      return false;
    }

    // Make a small request to a reliable server
    await fetch("https://www.google.com", {
      mode: "no-cors",
      cache: "no-store",
    });

    return true;
  } catch (error) {
    return false;
  }
};

export const getGeneralErrorMessage = async (
  error: unknown
): Promise<string> => {
  let errorMessage = "An unexpected error occurred. Please try again later.";

  const isOnline = await checkInternetConnectivity();

  if (!isOnline) {
    return "You appear to be offline. Please check your internet connection and try again.";
  }

  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<{
      message: string;
      status: boolean;
    }>;

    if (axiosError.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (axiosError.response.data?.status === false) {
        errorMessage =
          axiosError.response.data?.message ||
          "Login failed. Please check your credentials and try again.";
      } else if (axiosError.response.status === 401) {
        errorMessage =
          "Invalid credentials. Please check your email and password.";
      } else if (axiosError.response.status === 403) {
        errorMessage = "Access denied. You don't have permission to log in.";
      } else if (axiosError.response.status >= 500) {
        errorMessage =
          "We're experiencing server issues. Please try again later.";
      }
    } else if (axiosError.request) {
      // The request was made but no response was received
      errorMessage =
        "Unable to reach bellu.ai. The server might be down or you might have connection issues. Please try again later.";
    } else {
      // Something happened in setting up the request that triggered an Error
      errorMessage =
        "An error occurred while sending the request. Please try again.";
    }
  }
  return errorMessage;
};
